export const iconFontAwesomeChildhoodGamepad = (
	<i className="fa-solid fa-gamepad"></i>
);
